"use strict";

import React, {useState, useEffect} from 'react';
import { render } from 'react-dom';
import axios from "../axiosWrapper";
import objectPath from "object-path";
import ProductGallery from "./component/ProductGallery";
import preloadImages from "../preloadImages";
import size from "../size";

export default ()=>{
    const galleryEl = document.getElementById('product-detail__slides__component');

    let defaultImage = [];
    let supportingImages = [];

    const adjustContainerEl = (mainEl=null, serverRenderedDisplay=null,) => {
        return new Promise((resolve, reject)=>{
            if(!!mainEl){
                mainEl.select
                mainEl.style.minHeight = `${size.outerHeight(mainEl)}px`;
                mainEl.style.position = `relative`;
                if(!!serverRenderedDisplay){
                    serverRenderedDisplay.style.position = 'absolute';
                    serverRenderedDisplay.style.top = '0';
                    serverRenderedDisplay.style.left = '0';
                    serverRenderedDisplay.style.right = '0';
                    serverRenderedDisplay.style.marginBottom = '1.25rem';
                }
                mainEl.offsetHeight;
                resolve();
            }
            else
                reject();
        });
    }

    const newGalleryContainer = (mainEl=null)=>{
        const containerEl = document.createElement('div');
        containerEl.style.marginBottom = '1.25rem';
        mainEl.appendChild(containerEl);
        return containerEl;
    }

    const cleanUpContainerEl = (mainEl=null, serverRenderedDisplay=null,) => {
        setTimeout(()=>{
            if(!!mainEl)
                mainEl.style.minHeight = 'auto';
            if(!!serverRenderedDisplay)
                serverRenderedDisplay.parentNode.removeChild(serverRenderedDisplay);
        }, 500);
    }

    if(!!galleryEl) {
        const sliderElData = {...(galleryEl.dataset)};
        if(!!sliderElData.productId){
            axios.get(`/products/${encodeURIComponent(sliderElData.productId)}/images/`).then((response)=>{
                defaultImage = objectPath.get(response, 'data.default_image', {});
                supportingImages = objectPath.get(response, 'data.supporting_images', []);
                if(!!defaultImage.enlarged_name){
                    const initialPath = '/assets/img/products/large/';
                    const imagesToPreload = [`${initialPath}${defaultImage.enlarged_name}`];
                    if(!!supportingImages && supportingImages.length){
                        supportingImages.slice(0,2).forEach((img)=>{
                            !!img.enlarged_name && imagesToPreload.push(`${initialPath}${img.enlarged_name}`);
                        });
                    }
                    preloadImages(imagesToPreload).finally(()=>{
                        const serverRenderedDisplay = !!galleryEl && galleryEl.querySelector('[data-images-list]');
                        adjustContainerEl(galleryEl, serverRenderedDisplay).finally(()=>{
                            const containerEl = newGalleryContainer(galleryEl);
                            render(
                                <ProductGallery slides={[defaultImage].concat(supportingImages)} />
                                ,containerEl, ()=>{
                                    cleanUpContainerEl(galleryEl, serverRenderedDisplay);
                                }
                            )
                        });
                    });
                }
            })
        }
    }
};
